<template>
<v-expansion-panel-content>
    <v-row
        dense
        v-for="(good, i) in goods"
        :key="shopid + i"
        >
        <v-col class="text-left" cols=3>
            <span>
                {{ (good.category || "-").slice(0,9) }}
            </span>
        </v-col>
        <v-col class="text-left" cols=4>
            <span>
                {{ (good.vendor || "-").slice(0,12)}}
            <span v-if="good.vendor && good.vendor.length > 12">..</span>
            </span>
        </v-col>
        <v-col class="text-right" cols=2>
            <span>
                {{ good.count }}
            </span>
        </v-col>
        <v-col class="text-right" cols=3>
            <span>
                {{ good.money | money }}
            </span>
        </v-col>
    </v-row>

</v-expansion-panel-content>
</template>

<script>


export default {
name: 'ShopGoods',
props: {
    goods: {
        type: Array,
    },
    shopid: {
        type: String,
    },
},
data: () => ({
}),
 
computed: {

},

methods: {

},

watch: {
   
},

created: function() {
}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
